/** CH315 功能定义中明确给出的固定尺寸与数量。 */
export const CH315_LAYOUT = {
  keyCount: 96,
  configCount: 4,
  layerCount: 4,
  configStride: 0x5000,
  flashRegionBytes: 0x1000,
  configCodecBytes: 0x400,
  layerCodecBytes: 0x200,
  rtBitmapBytes: 12,
  rtValuesBytes: 192,
  rtCodecBytes: 0x30c,
  keyMappingBytes: 4,
  rgbKeyBytes: 4,
  customRgbCodecBytes: 0x194,
  macroCount: 96,
  macroBytes: 512,
  macroNameBytes: 16,
  bulkDataChunkBytes: 496,
  normalReadChunkBytes: 52,
  normalWriteChunkBytes: 53,
} as const

export const CH315_CONFIG_OFFSET = {
  sequence: 0x0000,
  locks: 0x0004,
  backlightMode: 0x0008,
  system: 0x000c,
  dynamicEffects: 0x0010,
  sideLight: 0x0050,
  rtEnabled: 0x00e0,
  rtTrigger: 0x00ec,
  rtReset: 0x01ac,
  actuation: 0x026c,
  bottomDeadZone: 0x032c,
  name: 0x03ec,
  checksum: 0x03fc,
} as const

export const CH315_LAYER_OFFSET = {
  sequence: 0x0000,
  keys: 0x0004,
  reserved: 0x0184,
  checksum: 0x01fc,
} as const

export const CH315_KEY_TYPE = {
  disabled: 0x00,
  keyboard: 0x01,
  keyboardChord: 0x02,
  consumer: 0x03,
  power: 0x04,
  verticalWheel: 0x05,
  horizontalWheel: 0x06,
  macro: 0x07,
  function: 0x08,
  mouse: 0x09,
  mouseButton: 0x0a,
  modTap: 0x0b,
  toggle: 0x0c,
  dks: 0x0d,
  rs: 0x0e,
  socd: 0x0f,
  keyboardMouse: 0x10,
} as const
